<template>
  <div class="container mt" id="vue-app">

    <div class="mls-notice">
        <p style="margin-bottom:0;"><strong style="font-weight:700">PLEASE NOTE:</strong> Our applications do not currently support cutting and pasting text from Word, Excel, and other sources. To ensure a successful submission, please type your responses directly into the application instead of cutting and pasting from another document.  Files including longer texts can be uploaded on the second page.</p>
    </div>


      <div tabindex="0" role="alert" class="error-container" id="error">
          <div class="error" v-if="error">
            <p>There was an error with your submission. Make sure that you filled out all required fields. Please review the form, as we have marked the errors</p>
          </div>
      </div>

      <!-- View Property Details side box -->
      <div class="application-property-box">
      <button class="view-application-property btn" v-on:click="showProperty()">View Property Details</button>
      <div class="application-property-details property-item">
          <div v-if="propertyData.main_pic_link" class="image" :style="{'background-image': 'url(' + propertyData.main_pic_link + ')'}"></div>
                <div v-else class="image" style="background-image:url('/assets/images/default house image@2x.png')"></div>
                <p :class="'parcel-number ' + propertyData.hclrc_prop_type">Parcel Number: {{ propertyData.ppn }}</p>
                <p class="address uppercase">{{ propertyData.parcel_address }}</p>
                <p class="status">Inventory Status: {{ propertyData.public_status }}</p>
        </div>
      </div>
      <!-- end View Property Details side box -->

      

      <!-- Begin Form -->
      <form class="application">
          <fieldset required> 
                <legend tabindex="1" v-focus>Application Type:</legend>
                <p class="disclaimer my-0">Items with a strikethrough are not available for this parcel</p>
                <div>
                <input type="radio" name="appType" id="Lot_to_Yard" value="Lot-to-Yard" v-model="applicationType" :disabled="propertyData.no_lty == 'Yes'">
                <label for="Lot_to_Yard" id="Lot_to_Yard_label" :class="{ disabled: propertyData.no_lty == 'Yes' }">Lot-to-Yard</label>
                    <div class="infoLabel">
                        <button class="fas fa-info-circle" v-on:click="displayTooltip($event)" aria-label="More Information"></button>
                        <div class="info">Lot to Yard is available to adjacent owner-occupied residential properties only.</div>
                    </div><br>
                <input type="radio" name="appType" id="Gardens_and_Greens" value="Gardens and Greens" v-model="applicationType" :disabled="propertyData.no_g_and_g == 'Yes'">
                <label for="Gardens_and_Greens" id="Gardens_and_Greens_label" :class="{ disabled: propertyData.no_g_and_g == 'Yes' }">Gardens and Greens</label>
                    <div class="infoLabel">
                        <button class="fas fa-info-circle" v-on:click="displayTooltip($event)"></button>
                        <div class="info">Gardens and Greens is available for transformation of vacant Landbank lots (e.g. commercial garden or playground).</div>
                    </div><br>
                <input type="radio" name="appType" id="Single_Family_Home_Development" value="Single Family Home Development" v-model="applicationType" :disabled="propertyData.no_sfhd == 'Yes'">
                <label for="Single_Family_Home_Development" id="Single_Family_Home_Development_label" :class="{ disabled: propertyData.no_sfhd == 'Yes' }">Single Family Home Development</label>
                 <div class="infoLabel">
                     <button class="fas fa-info-circle" v-on:click="displayTooltip($event)"></button>
                    <div class="info">This application is for renovation and new builds of single family homes, it also includes owner occupied two-family structures.</div>
                </div><br>
                <input type="radio" name="appType" id="Commercial_Development" value="Commercial Development" v-model="applicationType" :disabled="propertyData.no_cd == 'Yes'">
                <label for="Commercial_Development" id="Commercial_Development_label" :class="{ disabled: propertyData.no_cd == 'Yes' }">Commercial Development</label>
                <div class="infoLabel">
                    <button class="fas fa-info-circle" v-on:click="displayTooltip($event)"></button>
                    <div class="info">This application is for multi-family residential structures, commercial projects or projects that include two or more properties.</div>
                </div>
                </div>
          </fieldset>
          <div class="line"></div>
    
    <div v-if="applicationType != ''">
        <h2>{{ applicationType }} Application</h2>

        <div class="form-fields">
            <div class="form-item">
                <p class="warning" role="alert">This is a required field</p>
                <label for="app_hamilton">If an individual, do you currently live or will live in Hamilton County?</label>
                <select name="app_hamilton" id="app_hamilton" v-model="app_hamilton" required>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                    <option value="NA">N/A</option>
                </select>
            </div>

            <div class="form-item">
                <p class="warning" tabindex="0" role="alert">This is a required field</p>
                <label for="app_sos">If an entity, are you properly registered with the State of Ohio?</label>
                <select name="app_sos" id="app_sos" v-model="app_sos" required>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                    <option value="NA">N/A</option>
                </select>
            </div>

           
             

            <!-- Application Checks REQUIRED -->
            <h3 class="mt-5">If you answer yes to any of the following questions, you may not be allowed to purchase a property from HCLRC. Do you:</h3>
            <div class="infoLabel">
                <button class="fas fa-info-circle" aria-label="More Information" v-on:click="displayTooltip($event)"></button>
                <div class="info large">Eligibility screening is an integral part of ensuring property transfers align with the mission of the Landbank.  We strive to work with qualified applicants to assist them with eligibility.</div>
            </div>
            
            <div class="form-item">
                <p class="warning" tabindex="0" role="alert">This is a required field</p>
                <label for="disp_app_code_check">Have outstanding orders for the violation of state or local property codes</label>
                <select name="disp_app_code_check" id="disp_app_code_check" v-model="disp_app_code_check" required>
                    <option value="Yes">Yes</option>
                    <option value="No" selected="selected">No</option>
                </select>
            </div>

            <div class="form-item">
                <p class="warning" tabindex="0" role="alert">This is a required field</p>
                <label for="disp_nui_history_check">Have a history of owning a property in a chronic nuisance state</label>
                <select name="disp_nui_history_check" id="disp_nui_history_check" v-model="disp_nui_history_check" required>
                    <option value="Yes">Yes</option>
                    <option value="No" selected="selected">No</option>
                </select>
            </div>

            <div class="form-item">
                <p class="warning" tabindex="0" role="alert">This is a required field</p>
                <label for="disp_pros_check">Been the subject of criminal/civil prosecution for property maintenance code infractions within the last five years</label>
                <select name="disp_pros_check" id="disp_pros_check" v-model="disp_pros_check" required>
                    <option value="Yes">Yes</option>
                    <option value="No" selected="selected">No</option>
                </select>
            </div>

            <div class="form-item">
                <p class="warning" tabindex="0" role="alert">This is a required field</p>
                <label for="disp_deltax_check">Own a property in tax delinquent status</label>
                <select name="disp_deltax_check" id="disp_deltax_check" v-model="disp_deltax_check" required>
                    <option value="Yes">Yes</option>
                    <option value="No" selected="selected">No</option>
                </select>
            </div>

            <div class="form-item">
                <p class="warning" tabindex="0" role="alert">This is a required field</p>
                <label for="disp_ff_check">Own real property on which any foreclosure filing has commenced within the last five years</label>
                <select name="disp_ff_check" id="disp_ff_check" v-model="disp_ff_check" required>
                    <option value="Yes">Yes</option>
                    <option value="No" selected="selected">No</option>
                </select>
            </div>

            <div class="form-item mt-4">
                <label for="disp_check_note">If yes to any of the above, please provide explanation (500 character limit)</label>
                <textarea id="disp_check_note" maxlength="500" v-model="disp_check_note"></textarea>
            </div>

            <div class="form-item">
                <label for="disp_check_owned_properties" class="infoLabel"> Please list the address and/or parcel number of all property in Hamilton County that the Applicant currently owns or has owned in the last three years.</label>
                <div class="infoLabel">
                    <button class="fas fa-info-circle" v-on:click="displayTooltip($event)"></button>
                    <div class="info large">Provide the addresses of any property you or your business (partial or whole interest) have owned in the past 3 years.</div>
                </div>
                <input type="text" id="disp_check_owned_properties" v-model="disp_check_owned_properties">
            </div>


        </div>

        <h3 class="mt-5">Redevelopment Details:</h3>

        <!-- REQUIRED -->
        <div class="form-item" v-if="displayFields.indexOf('redev_detail_lottoyard') !== -1">
            <p class="warning" role="alert">This is a required field</p>
            <label for="redev_detail_lottoyard">Tell us how you would like to incorporate this vacant lot into your existing property</label>
            <textarea id="redev_detail_lottoyard" v-model="redev_detail" required></textarea>
        </div>
        

        <div class="form-item" v-if="displayFields.indexOf('redev_detail_gardens') !== -1">
            <p class="warning" role="alert">This is a required field</p>
            <label for="redev_detail_gardens" maxlength="500">Tell us about how you would landscape and maintain the lot, including your plan for financing the improvements if necessary.</label>
            <textarea id="redev_detail_gardens" v-model="redev_detail" required></textarea>
        </div>

        <div class="form-item" v-if="displayFields.indexOf('redev_detail_single') !== -1">
            <p class="warning" role="alert">This is a required field</p>
            <label for="redev_detail_single" maxlength="500">Describe your intended scope of work.  Do you believe the property needs a new roof?  Will you paint, install new floors, tuckpoint and landscape?  Will this work need permits?  Please note: Most applicants have not seen inside the property before submitting an application.  Base your expected redevelopment on known issues or typical condition of similar buildings.  If your application is approved, you will have the opportunity to tour the property to determine final estimates and continued interest in the property.</label>
            <textarea id="redev_detail_single" v-model="redev_detail" required></textarea>
        </div>


        <fieldset id="sf_project_type" v-if="displayFields.indexOf('sf_project_type') !== -1" class="form-item" required> <!-- REQUIRED -->
            <p class="warning" role="alert">Project Type is a required field</p>
                <legend>Project Type:</legend>
                <input type="radio" name="sf_project_type" id="rehab" value="Rehab of structure" v-model="sf_project_type">
                <label for="rehab" class="radioLabel">Rehab of structure</label><br>
                <input type="radio" name="sf_project_type" id="New_construction" value="New construction" v-model="sf_project_type">
                <label for="New_construction" class="radioLabel">New construction</label><br>
                <input type="radio" name="sf_project_type" id="development" value="Incorporate vacant lot into planned single family development" v-model="sf_project_type">
                <label for="development" class="radioLabel">Incorporate vacant lot into planned single family development</label>
          </fieldset>



            <fieldset id="com_project_type" v-if="displayFields.indexOf('com_project_type') !== -1" class="form-item" required>  <!-- REQUIRED -->
                <p class="warning" role="alert">Project Type is a required field</p>
                <legend>Project Type:</legend>
                <input type="radio" name="com_project_type" id="Renovation" value="Renovation" v-model="com_project_type">
                <label for="Renovation" class="radioLabel">Renovation</label><br>
                <input type="radio" name="com_project_type" id="New_construction" value="New construction" v-model="com_project_type">
                <label for="New_construction" class="radioLabel">New construction</label>
          </fieldset>

        <div class="form-item" v-if="displayFields.indexOf('redev_detail_com') !== -1" required>
            <p class="warning" role="alert">This is a required field</p>
            <label for="redev_detail_com" maxlength="500">Describe your development. What do you want to do with this property?  What work will be required, and will this work need to be permitted?  Please note: Most applicants have not seen inside the property before submitting an application.  Base your expected redevelopment on know issues or typical condition of similar buildings. There will be a period of due diligence once your application has been reviewed prior to final approval.* (*You may be asked to give a Live Pitch of your project to our leadership. If a Live Pitch is required you will be notified and given time to prepare all necessary budgets, renderings (if applicable), powerpoints or other relavent documents.)</label>
            <textarea id="redev_detail_com" v-model="redev_detail"></textarea>
        </div>

        <div class="form-item" v-if="displayFields.indexOf('time_line') !== -1" required>
            <p class="warning" role="alert">This is a required field</p>
            <label for="time_line">How long will construction/rehab take to complete?  What factors might affect this estimate?</label>
            <input type="text" id="time_line" v-model="time_line">
        </div>

        <div class="form-item" v-if="displayFields.indexOf('list_contractors') !== -1" required>
            <p class="warning" role="alert">This is a required field</p>
            <label for="list_contractors" class="infoLabel">Who will perform the work? List any known contractors, if you are not performing all work yourself.</label>
            <div class="infoLabel">
                <button class="fas fa-info-circle" v-on:click="displayTooltip($event)"></button>
                <div class="info large">Will you perform the work yourself, utilize contractors or both?  If you know which contractors you anticipate using, please list.</div>
            </div>
            <input type="text" id="list_contractors" v-model="list_contractors">
        </div>

        <div class="form-item" v-if="displayFields.indexOf('list_experience') !== -1">
            <p class="warning" role="alert">This is a required field</p>
            <label for="list_experience" maxlength="500" class="infoLabel">Describe any experience you have rehabbing and construction.</label>
            <div class="infoLabel">
                <button class="fas fa-info-circle" v-on:click="displayTooltip($event)"></button>
                <div class="info large">Photos of past projects are welcome and can be uploaded at the end of this application.  Lack of experience will not disqualify an applicant so long as there are other ways to ensure a project’s success.</div>
            </div>
            <textarea id="list_experience" v-model="list_experience" required></textarea>
        </div>

         <fieldset id="end_use" v-if="displayFields.indexOf('end_use') !== -1" class="form-item" required>
                <p class="warning" role="alert">Intended Use of Property is a required field</p>
                <legend>Intended Use of Property:</legend>
                <input type="radio" name="end_use" id="occupy" value="Applicant will occupy property" v-model="end_use">
                <label for="occupy" class="radioLabel">Applicant will occupy property</label><br>
                <input type="radio" name="end_use" id="sell" value="Applicant will sell redeveloped property" v-model="end_use">
                <label for="sell" class="radioLabel">Applicant will sell redeveloped property</label><br>
                <input type="radio" name="end_use" id="lease" value="Applicant will lease redeveloped property" v-model="end_use">
                <label for="lease" class="radioLabel">Applicant will lease redeveloped property</label>
          </fieldset>

          <div class="form-item" v-if="displayFields.indexOf('end_price') !== -1">
            <p class="warning" role="alert">This is a required field if you intend to sell or lease the property</p>
            <label for="end_price">If you intend to sell or lease the property, what price do you expect to receive?</label>
            <input type="text" id="end_price" v-model="end_price">
        </div>

         <div class="form-item" v-if="displayFields.indexOf('partner_support') !== -1">
            <label for="partner_support">If you will be working with any partners, neighborhood groups, non‐profits, or neighbors on this project, tell us about who you will be working with and how</label>
            <textarea id="partner_support" maxlength="500" v-model="partner_support"></textarea>
        </div>

        <div class="form-item" v-if="displayFields.indexOf('work_completed') !== -1">
            <label for="work_completed">Describe any work you have already completed on this project?  Do you have plans or architectural drawings?  Have you had any discussion with local municipality or economic development entities?</label>
            <textarea id="work_completed" maxlength="500" v-model="work_completed"></textarea>
        </div>



        <div class="textblock" v-if="applicationType==='Commercial Development'">
            <h3>The Pitch</h3>
            <p>The Port Authority development staff reviews all HCLRC applications and will contact you with
either denial or preliminary approval of the project. All approved Applicants for Multi‐unit, Multi‐
property, and Commercial developments are required to give a live pitch of their development to
the Port Authority staff at our office at 3 E. 4th St., Suite 300, Cincinnati, OH 45202. For your pitch
you should be prepared to present and discuss the following:</p>
            <ul>
                <li>Your development experience and completed past projects</li>
                <li>End‐product of the development</li>
                <li>Partners/Contractors that will be involved in this project</li>
                <li>Detailed financial plan for development costs</li>
                <li>Details of owner equity and debt financing</li>
                <li>Details of any expected/assumed public subsidy</li>
                <li>Post‐development cash flow statement</li>
                <li>Maintenance plan for maintaining properties during construction</li>
                <li>Community support for the project</li>
            </ul>
        </div>

        <div class="textblock" v-if="applicationType=='Lot-to-Yard'">

            <h3>Basic Disposition Requirements:</h3>
            <ul>
                <li>The Applicant must own and reside in the house immediately adjacent to the property for which s/he is applying.</li>
                <li>The property must be vacant land or property targeted for demolition.</li>
                <li>The property must be on the HCLRC’s available properties list, available at http://www.hamiltoncountylandbank.org.</li>
                <li>If the subject property is in an area where we have a neighborhood‐based development partner, then the project must generally be approved by the applicable partner. The Landbank will solicit input from the partner when making its decision.</li>
            </ul>
        </div>

        <div class="textblock" v-if="applicationType=='Single Family Home Development'">

            <h3>Basic Disposition Requirements:</h3>
            <ul>
                <li>Applicant must have the capacity to undertake the redevelopment of the property.</li>
                <li>The property must be a vacant, residential lot or a single‐family structure.</li>
                <li>The Applicant must plan on rehabilitating a single‐family structure, newly constructing a single‐family home on a residential lot, or incorporating a vacant residential lot into an ongoing or planned single‐family home development.</li>
                <li>The property must be on the HCLRC’s available properties list, available at www.hamiltoncountylandbank.org.</li>
                <li>If the subject property is in an area where we have a neighborhood‐based development partner, then the project must generally be approved by the applicable partner. The Landbank will solicit input from the partner when making its decision.</li>
            </ul>
        </div>

        <div class="textblock" v-if="applicationType=='Gardens and Greens'">

            <h3>Basic Disposition Requirements:</h3>
            <ul>
                <li>Applicant must have the capacity to undertake the greening and maintenance of the lot.</li>
                <li>The property must be vacant land or property targeted for demolition.</li>
                <li>The property must be on the HCLRC’s available properties list, available at www.hamiltoncountylandbank.org.</li>
                <li>If the subject property is in an area where we have a neighborhood‐based development partner, then the project must generally be approved by the applicable partner. The Landbank will solicit input from the partner when making its decision.</li>
            </ul>
        </div>

         <div class="textblock" v-if="applicationType=='Commercial Development'">

            <h3>Basic Disposition Requirements:</h3>
            <ul>
                <li>Applicant must have the capacity to undertake the redevelopment of the property.</li>
                <li>The project must include the development of a multiple units, multiple properties, or a commercial property.</li>
                <li>The property must be on the HCLRC’s available properties list, available at www.hamiltoncountylandbank.org, or the HCLRC must give the Applicant prior approval of the acquisition of the parcel.</li>
                <li>If the subject property is in an area where we have a neighborhood‐based development partner, then the project must generally be approved by the applicable partner. The Landbank will solicit input from the partner when making its decision.</li>
            </ul>
        </div>

        <div class="textblock" v-if="applicationType=='Lot-to-Yard'">
            <h3>General Terms of Sale:</h3>
            <ul>
                <li>Purchase Price: Pricing varies based on the investment required for the redevelopment, the market value of the property, and the beneficial economic impact of the proposed project.</li>
                <li>Redevelopment Terms: All purchasers are required to incorporate the vacant lot into the purchaser’s adjacent property. This may include installing a fence, landscaping the property, or seeding a lawn.</li>
                <li>After the transaction, Purchasers may not sell the vacant lot separate from the adjoining property.</li>
                <li>Maintenance: The purchaser must agree to maintain the lot attractively.</li>
                <li>Property Taxes: The purchaser must agree to timely pay all property taxes that become due after the transfer.</li>
            </ul>
        </div>

        <div class="textblock" v-if="applicationType=='Single Family Home Development'">
            <h3>General Terms of Sale:</h3>
            <ul>
                <li>Purchase Price: Pricing varies based on the investment required for the redevelopment, the market value of the property, and the beneficial economic impact of the proposed project.</li>
                <li>Redevelopment Terms: All purchasers will be contractually required to develop the proposed project within specific time frames.</li>
                <li>Maintenance: The purchaser must maintain the property during and after the redevelopment.</li>
                <li>Property Taxes: The purchaser must agree to timely pay all property taxes that become due after the transfer.</li>
            </ul>
        </div>

        <div class="textblock" v-if="applicationType=='Gardens and Greens'">
            <h3>General Terms of Sale:</h3>
            <ul>
                <li>Purchase Price: Pricing varies based on the investment required for the redevelopment, the market value of the property, and the beneficial economic impact of the proposed project.</li>
                <li>Redevelopment Terms: All purchasers are required to green and landscape the vacant lot.  This may include planting a garden or landscaping the property.</li>
                <li>Maintenance: The purchaser must agree to maintain the lot as a garden or landscaped green space.</li>
                <li>Property Taxes: The purchaser must agree to timely pay all property taxes that become due after the transfer.</li>
            </ul>
        </div>

        <div class="textblock" v-if="applicationType=='Commercial Development'">
            <h3>General Terms of Sale:</h3>
            <ul>
                <li>Purchase Price: Pricing varies based on the investment required for the redevelopment, the market value of the property, and the beneficial economic impact of the proposed project.</li>
                <li>Redevelopment Terms: All purchasers will be contractually required to develop the proposed project within specific time frames.</li>
                <li>Maintenance: The purchaser must maintain the property during the redevelopment.</li>
                <li>Property Taxes: The purchaser must agree to timely pay all property taxes that become due after the transfer.</li>
            </ul>
        </div>


        <div class="form-item">
            <p class="warning" role="alert">Signature required</p>
             <label for="signature" maxlength="500" required>Please enter your first and last name as an electronic signature. This signifies that the information on this application is true and accurate.</label>
            <input type="text" id="signature" v-model="signature">
        </div>

          
    </div>
          
    </form>
    
    <div class="application-button-container" v-if="applicationType != ''">
        <button class="btn btn-primary" v-on:click="send">Continue</button>
                <double-bounce v-if="loading"></double-bounce>
        <p class="disclaimer">NOTE: You cannot return back to this section of the application once you continue.</p>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
import {DoubleBounce} from 'vue-loading-spinner';


$(document).mouseup(function(e) 
{
    var container = $(".infoLabel");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
        $('.info').each(function() {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
            }
        })
    }
});



export default {
  name: 'ApplicationDetail',

  components: {
      DoubleBounce,
  },

  data() {
    return {
        propertyData: [],
        applicationType: '',
        app_hamilton: 'Yes',
        app_sos: 'Yes',
        disp_app_code_check: 'No',
        disp_nui_history_check: 'No',
        disp_pros_check: 'No',
        disp_deltax_check: 'No',
        disp_ff_check: 'No',
        disp_check_note: '',
        disp_check_owned_properties: '',
        com_project_type: '',
        sf_project_type: '',
        redev_detail: '',
        time_line: '',
        list_contractors: '',
        list_experience: '',
        end_use: '',
        end_price: '',
        partner_support: '',
        work_completed: '',
        signature: '',
        required_fields: {},
        error: false,
        loading: false,

    }
  },
  created() {
      // Scroll to the top of the page since the Vue app will just keep you down where you were
        window.scrollTo(0,0);

        // Get property detail information from API
        axios.get('/wp-json/HCLRC/v1/publish-hclrc-parcel-detail/', {
            params: {
                'ppn' : this.$route.params.property_id 
            }
        })
        .then((response) => {
            this.$set(this, 'propertyData', response['data']['data']['data']['parcel_detail']['data'][0]);           

        })
        .catch(function (error) {
        // if an error occurs, print that error
        console.log(error);
        });

  },
  methods: {
      displayTooltip(event) {
          this.$parent.displayTooltip(event);
      },
      showProperty() {
          if ($('.application-property-box').hasClass('active')) {
              $('.application-property-box').removeClass('active');
          } else {
                $('.application-property-box').addClass('active');
          }
          
      },
      send() {
          // Get required fields for each application type
          this.$set(this, 'loading', true);
          this.$set(this, 'required_fields', {
              'app_hamilton': this.app_hamilton, 
              'app_sos': this.app_sos,
              'disp_app_code_check': this.disp_app_code_check,
               'disp_nui_history_check': this.disp_nui_history_check,
               'disp_pros_check': this.disp_pros_check,
               'disp_deltax_check': this.disp_deltax_check,
               'disp_ff_check': this.disp_ff_check,
               'redev_detail': this.redev_detail,
               'signature': this.signature
            });

            // Add in additional required fields for Single and Commercial Development application types
            if (this.applicationType == 'Single Family Home Development') {
                this.required_fields['sf_project_type'] = this.sf_project_type;
                this.required_fields['time_line'] = this.time_line;
                this.required_fields['list_contractors'] = this.list_contractors;
                this.required_fields['list_experience'] = this.list_experience;
                this.required_fields['end_use'] = this.end_use;
                if (this.end_use == 'Applicant will sell redeveloped property' || this.end_use == 'Applicant will lease redeveloped property') {
                    this.required_fields['end_price'] = this.end_price;
                }
            } else if (this.applicationType == 'Commercial Development') {
                this.required_fields['com_project_type'] = this.com_project_type;
                this.required_fields['work_completed'] = this.work_completed;
                this.required_fields['time_line'] = this.time_line;
                this.required_fields['list_contractors'] = this.list_contractors;
                this.required_fields['end_use'] = this.end_use;
                if (this.end_use == 'Applicant will sell redeveloped property' || this.end_use == 'Applicant will lease redeveloped property') {
                    this.required_fields['end_price'] = this.end_price;
                }

            }

            this.$set(this, 'error', false);
            $('.form-item').each(function() {
                $(this).removeClass('warning');
            })
            // Check and make sure that all required fields are filled out
            for (var item in this.required_fields) {
                if (this.required_fields[item] == '') {

                    // Display generic error message and scroll it into view
                    this.$set(this, 'error', true);
                    window.scrollTo(0,0);
                    document.getElementById('error').focus();
                    this.$set(this, 'loading', false);


                    // Pick the correct field if the error is with redev_detail 
                    if (item == 'redev_detail') {
                        if (this.applicationType == 'Lot-to-Yard') {
                            $('#redev_detail_lottoyard').closest('.form-item').addClass('warning');
                        } else if (this.applicationType == 'Gardens and Greens') {
                            $('#redev_detail_gardens').closest('.form-item').addClass('warning');
                        } else if (this.applicationType == 'Single Family Home Development') {
                            $('#redev_detail_single').closest('.form-item').addClass('warning');
                        } else {
                            $('#redev_detail_com').closest('.form-item').addClass('warning');
                        }
                    } else {
                        // Highlight each field that is required
                        $('#' + item).closest('.form-item').addClass('warning');

                    }
                }
            }

            // If there are no errors, create the application
            if (!this.error) {

                // Add fields common to all applications that require a value
                var dataObject = {
                    app_parcel: this.$route.params.property_id, 
                    disp_app_type: this.applicationType,
                    app_hamilton: this.app_hamilton,
                    app_sos: this.app_sos,
                    disp_app_code_check: this.disp_app_code_check,
                    disp_nui_history_check: this.disp_nui_history_check,
                    disp_pros_check: this.disp_pros_check,
                    disp_deltax_check: this.disp_deltax_check,
                    disp_ff_check: this.disp_ff_check,
                    redev_detail: this.redev_detail,
                    signature: this.signature,
                }

                // Check the not required fields to see if they're empty or if they need to be sent
                if (this.disp_check_note != '') {
                    dataObject.disp_check_note = this.disp_check_note;
                }
                if (this.disp_check_owned_properties != '') {
                    dataObject.disp_check_owned_properties = this.disp_check_owned_properties;
                }

                // Check fields specific to SF and Comm applications
                if (this.applicationType == 'Single Family Home Development') {
                    dataObject.sf_project_type = this.sf_project_type;
                    dataObject.time_line = this.time_line;
                    dataObject.list_contractors = this.list_contractors;
                    dataObject.list_experience = this.list_experience;
                    dataObject.end_use = this.end_use;

                    if (this.end_price != '') {
                        dataObject.end_price = this.end_price;
                    }
                }

                if (this.applicationType == 'Commercial Development') {
                    dataObject.com_project_type = this.com_project_type;
                    dataObject.time_line = this.time_line;
                    dataObject.list_contractors = this.list_contractors;
                    dataObject.end_use = this.end_use;
                    dataObject.work_completed = this.work_completed;

                    if (this.end_price != '') {
                        dataObject.end_price = this.end_price;
                    }
                }




                axios.post('/wp-json/HCLRC/v1/create-public-application', dataObject
                ).then(res => {
                    console.log(res);
                    if (res.data.data.message == 'INVALID USER') {
                        this.$router.push({path: '/available-properties/login', query: {fromApplication: true, redirect: '/available-properties/applications/' + this.$route.params.property_id }});
                    } else if (res.data.data.data.application_id) {
                        var applicationId = res.data.data.data.application_id;
                        this.$router.push('/available-properties/applications/' + this.$route.params.property_id + '/' + applicationId + '/?applicationType=' + this.applicationType);
                    } else {
                        this.$set(this, 'loading', false);
                        this.$router.push({path: '/available-properties/login', query: {fromApplication: true, redirect: '/available-properties/applications/' + this.$route.params.property_id }});
                    }
                })
                .catch(function (error) {
                    // if an error occurs, we're assuming it was a fluke and are making them login again
                    this.$set(this, 'loading', false);
                    this.$router.push({path: '/available-properties/login', query: {fromApplication: true, redirect: '/available-properties/applications/' + this.$route.params.property_id }});



                });
                
            }

          // Send API Request

          // check response
      }
  },
  computed: {
      displayFields() {
          if (this.applicationType == 'Lot-to-Yard') {
              return ['redev_detail_lottoyard'];
          } else if (this.applicationType == 'Gardens and Greens') {
              return ['partner_support', 'redev_detail_gardens'];
          } else if (this.applicationType == 'Single Family Home Development') {
              return ['end_price', 'end_use', 'list_contractors', 'list_experience', 'redev_detail_single', 'sf_project_type', 'time_line'];
          } else if (this.applicationType == 'Commercial Development') {
              return ['end_price', 'end_use', 'list_contractors', 'redev_detail_com', 'com_project_type', 'time_line', 'work_completed'];
          } else {
            return [];
          }
      },
     
      
  }
}
</script>
<!-- styling for the component -->
<style lang="scss">



form.application {
    width: 75%;
    margin: 0 auto;

    h3 {
        text-transform: none;
        font-size: 1.5rem;
        display: inline;
    }
    .line {
        height: 1px;
        width: 100%;
        background-color:rgba(39, 106, 166, .5);
        margin-bottom: 2rem;
    }

    
    textarea {
        height: 100px;
        width: 100%;
    }
    .textblock {
        margin: 2rem 0;
    }

    .radioLabel {
        margin-right: 1rem;
    }
   
}

.form-item {
    label {
        display: block;
       
    }
    input[type="text"] {
        width: 100%;
    }
   
    
}

fieldset {
    margin-bottom: 1.5rem;
    display: block;
    legend {
        font-weight: 700;
        font-size: 1rem;
        margin-bottom: .25rem;
        width: fit-content;
    }
    label {
        display: inline-block !important;
         &.disabled {
            text-decoration: line-through;
        }
    }
    br {
        display: none;
    }
}

.infoLabel {
    .fa-info-circle {
        background-color: unset;
    }
}

.application-property-box {
    position: fixed;
    right: -300px;
    z-index: 999;
    transition: all .5s;

    button {
        transition: all .5s;
       position: absolute;
       transform: rotate(90deg);
       right: 178px;
       padding: 12px;
       top: 122px;
       width: 300px;
       background-color: #174F80;
       color: #fff;
    }
    .application-property-details {
        width: 300px;
        height: 300px;
        overflow: hidden;
        padding: 1rem;
        margin: 0;
        background-color: #fff;
    }
    &.active {
        right: 0;

    }
}
.application-button-container {
    position: relative;
    .spinner {
        margin: 0 auto;
        position: relative !important;
        top: 1rem;
    }

}

@media screen and (max-width: 1200px) {
    form.application {
        width: 100%;
        fieldset {
            br {
                display: block;
            }
        }
    }
}



</style>


// WEBPACK FOOTER //
// src/components/Application/ApplicationDetail.vue